/** Belegarten der Verkaufs- und Einkaufskette (docs/SPEC.md 4.1). */
export const DOCUMENT_TYPES = [
    'QUOTE',
    'ORDER',
    'DELIVERY_NOTE',
    'INVOICE',
    'CANCELLATION',
    'CREDIT_NOTE',
    'PURCHASE_ORDER',
];
/** Cancellation requires an existing invoice; purchasing uses its own editor. */
export function salesDocumentTypesForPartner(partner) {
    if (partner.isCustomer)
        return ['QUOTE', 'ORDER', 'DELIVERY_NOTE', 'INVOICE', 'CREDIT_NOTE'];
    return partner.isProspect ? ['QUOTE'] : [];
}
/** Ambiguous delivery destinations require an explicit choice. */
export function defaultShippingAddress(addresses) {
    const shipping = addresses.filter((address) => address.type === 'SHIPPING');
    const defaults = shipping.filter((address) => address.isDefault);
    return defaults.length === 1
        ? (defaults[0] ?? null)
        : shipping.length === 1
            ? (shipping[0] ?? null)
            : null;
}
export const DOCUMENT_TAX_STRATEGIES = [
    'REGULAR',
    'REVERSE_CHARGE',
    'INTRA_COMMUNITY',
    'EXPORT_NON_EU',
];
export const DOCUMENT_ITEM_TYPES = ['ARTICLE', 'TEXT', 'SUBTOTAL', 'DISCOUNT', 'SHIPPING'];
/**
 * Zahlungsart des Belegs. Bezeichner bleiben englisch (Regel 1 der Repo-Vorgaben);
 * die Oberfläche beschriftet sie deutsch als Rechnung, Vorkasse und Barzahlung.
 */
export const DOCUMENT_PAYMENT_METHODS = ['INVOICE', 'PREPAYMENT', 'CASH'];
/** Zahlungsarten ohne Ausfallrisiko; nur sie erlauben eine Freigabe trotz Sperre. */
export const RISK_FREE_PAYMENT_METHODS = ['PREPAYMENT', 'CASH'];
export function isRiskFreePaymentMethod(method) {
    return RISK_FREE_PAYMENT_METHODS.includes(method);
}
export const DOCUMENT_STATUSES = [
    'DRAFT',
    'SENT',
    'ACCEPTED',
    'REJECTED',
    'CONFIRMED',
    'IN_PROGRESS',
    'PARTIALLY_PROCESSED',
    'SHIPPED',
    'COMPLETED',
    'POSTED',
    'CANCELLED',
];
/** Belegsprachen für Beschriftungen, Artikeltexte und PDF-Ausgabe. */
export const DOCUMENT_LANGUAGES = ['tr', 'fr', 'es', 'de', 'en'];
/** Sprachen mit vollständig gepflegten Standardtexten für PDF und Beleg-E-Mail. */
export const DOCUMENT_TRANSLATED_LANGUAGES = ['tr', 'fr', 'es', 'de', 'en'];
/** Existing documents remain readable; retired values are rejected by every write schema. */
export const STORED_DOCUMENT_LANGUAGES = [...DOCUMENT_LANGUAGES, 'ru'];
export const DOCUMENT_CURRENCIES = ['EUR', 'USD', 'CHF', 'GBP'];
export const DOCUMENT_SORT_FIELDS = [
    'number',
    'documentDate',
    'dueDate',
    'status',
    'paymentStatus',
    'grossTotal',
    'createdAt',
    'updatedAt',
];
export const DOCUMENT_ITEMS_MAX_COUNT = 500;
export const DOCUMENT_NUMBER_MAX_LENGTH = 100;
export const DOCUMENT_TEXT_MAX_LENGTH = 4000;
export const DOCUMENT_PAYMENT_TERMS_MAX_DAYS = 365;
/** Nummernkreis-Schlüssel je Belegart; die Vergabe läuft über `NumberRange`. */
export const DOCUMENT_NUMBER_RANGE_KEYS = {
    QUOTE: 'QUOTE',
    ORDER: 'ORDER',
    DELIVERY_NOTE: 'DELIVERY_NOTE',
    INVOICE: 'INVOICE',
    CANCELLATION: 'CANCELLATION',
    CREDIT_NOTE: 'CREDIT_NOTE',
    PURCHASE_ORDER: 'PURCHASE_ORDER',
};
/** Erlaubte Belegtransformationen (docs/SPEC.md 4.6). */
export const DOCUMENT_CONVERSIONS = {
    QUOTE: ['ORDER'],
    ORDER: ['DELIVERY_NOTE', 'INVOICE'],
    DELIVERY_NOTE: ['INVOICE'],
    INVOICE: ['CANCELLATION'],
    CANCELLATION: [],
    CREDIT_NOTE: [],
    PURCHASE_ORDER: [],
};
/** Belegarten, die Bestand bewegen — Erzeugung bucht Warenausgang. */
export const STOCK_RELEVANT_DOCUMENT_TYPES = ['DELIVERY_NOTE'];
/** Beträge werden auf Cent gerundet, Steuersätze mit sechs Nachkommastellen geführt. */
export const MONEY_SCALE = 2;
export const RATE_SCALE = 6;
/** Regelsteuersatz, der greift, wenn ein Beleg keine steuerpflichtige Position enthält. */
export const DEFAULT_TAX_RATE_PCT = '19';
export const EMAIL_SUBJECT_MAX_LENGTH = 200;
export const EMAIL_BODY_MAX_LENGTH = 20_000;
export const EMAIL_CC_MAX_COUNT = 5;
//# sourceMappingURL=documents.js.map